module.exports = __webpack_public_path__ + "static/media/home_intro_blue.06be6489.png";